// extracted by mini-css-extract-plugin
export var closeButton = "_1d-3";
export var header = "_1d-0";
export var link = "_1d-1";
export var retryButton = "_1d-2";